import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=47f83a0b&scoped=true&"
import script from "./AccessDenied.vue?vue&type=script&lang=js&"
export * from "./AccessDenied.vue?vue&type=script&lang=js&"
import style0 from "./AccessDenied.vue?vue&type=style&index=0&id=47f83a0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f83a0b",
  null
  
)

export default component.exports